<template>
  <div
    class="monitor-wrapper"
    :class="className"
    v-loading="loading.value"
    :element-loading-text="$t(loading.text)"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  inject: ['getLoading'],
  props: {
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    loading() {
      return this.getLoading();
    }
  }
};
</script>

<style lang="scss" scoped>
.monitor-wrapper {
  width: 100%;
  height: 100%;
}
</style>
